import * as React from 'react';
import { useState, useEffect } from 'react';
import styles from './assistantGroup.module.scss';
import doctor_photo from '../../static/images_pfizer/doctor_photo.png';
import addassistant from '../../static/images_pfizer/addassistant.png';
import applylist from '../../static/images_pfizer/applylist.png';
import qrcode from '../../static/images_pfizer/qrcode.png';
import commissioner from '../../static/images_pfizer/commissioner.png';
import volunteer from '../../static/images_pfizer/volunteer.png';
import nurse from '../../static/images_pfizer/nurse.png';
import { withRouter } from 'react-router-dom';
import { ApiCore } from '../../api/index';
const api = new ApiCore();

const AssistantGroup = (props: any) => {

    const [list, setList] = useState<any>([])
    const [count, setCount] = useState<any>(null)

    useEffect(() => {
        window.document.title = '我的团队'
        initCount();
        getData();
    }, [])

    const initCount = () => {
        api.getVisitTeamAssistantApplyCount().then((res: any) => {
            if (res.code == 0) {
                if (res.data) {
                    setCount(res.data);
                }
            }
        })
    }

    const getData = () => {
        api.getDoctorTeamAssistants().then((res: any) => {
            if (res.code == 0) {
                setList(res.data)
            }
        })
    }

    const toApplyList = () => {
        props.history.push('/pfizer/doctor/applyList');

    }

    const toTeamDetail = (val: any) => {
        props.history.push(`/pfizer/doctor/assistantGroupDetail?assistantCode=${val.assistanCode}`);
    }

    return (
        <div className={styles.assistantGroup}>
            <div className={styles.groupHeader}>
                <div className={styles.menu} onClick={() => { toApplyList() }}>
                    <img src={applylist} alt="" />
                    <div>申请列表</div>
                    {
                        count &&
                        <div className={styles.dot}>{count}</div>
                    }
                </div>
                <div className={styles.menu}>
                    <img src={qrcode} alt="" />
                    <div>我的二维码</div>
                </div>
                <div className={styles.menu}>
                    <img src={addassistant} alt="" />
                    <div>添加助理</div>
                </div>
            </div>

            <div className={styles.label}>
                我的助理
            </div>

            <div className={styles.assistant_list}>
                {
                    list.map((v: any, i: number) => (
                        <div className={styles.assistant_content} key={i} onClick={() => { toTeamDetail(v) }}>
                            <img className={styles.avatar} src={v.type == 'VOLUNTEER' ? volunteer : v.type == 'NURSE' ? nurse : commissioner} alt="" />
                            <div className={styles.content}>
                                <div className={styles.userInfo}>
                                    <div className={styles.info}>
                                        <span className={styles.name}>{v.assistantName}</span>
                                        {
                                            v.type == 'VOLUNTEER' ? <span className={styles.volunteer}>志愿者</span> :
                                                v.type == 'NURSE' ? <span className={styles.nurse}>护士</span> :
                                                    <span className={styles.occupation}>随访专员</span>
                                        }

                                    </div>
                                    <span className={styles.phone}></span>
                                </div>
                                {/* <div className={styles.taskInfo}>协管患者200人 本月完成100个随访任务</div> */}
                                <div className={styles.pName}>
                                    {
                                        v.groups.map((item: any, index: number) => (
                                            <div key={index}>{item.name}</div>
                                        ))
                                    }
                                </div>
                            </div>
                        </div>
                    ))
                }

            </div>

        </div>
    )
}

export default withRouter(AssistantGroup);